import { registerMiddleware, registerReducer } from "../../store";
import reducer from "./reducer"
import middleware from "./middleware";

export { default as Component } from "./components/GlobalSearchComponent"

/**
 * GlobalSearch has lazy load but no un-load
 */
registerReducer("globalSearch", reducer);
registerMiddleware("globalSearch", middleware);
